// src/pages/Contact.js
import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Thank you for your message! I\'ll get back to you soon.');
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <header className="contact-header">
          <h1 className="contact-title">Let's Talk!</h1>
          <div className="contact-accent" aria-hidden="true" />
          <p className="contact-subtitle">
            Ready to transform your data into actionable insights? Let's discuss your project.
          </p>
        </header>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-method">
              <h3>📧 Email</h3>
              <p>hello@raulco.org</p>
            </div>

            <div className="contact-method">
              <h3>💼 LinkedIn</h3>
              <p>linkedin.com/in/raulco</p>
            </div>

            <div className="contact-method">
              <h3>📍 Location</h3>
              <p>Available for remote work worldwide / California</p>
            </div>

            <div className="contact-method resume-download">
              <h3>📄 Resume</h3>
              <p>Download or view my latest resume</p>
              <div className="resume-buttons">
                <a
                  href="/Assets/PDFs/RaulCo_Resume.pdf"
                  download="Raul_Resume.pdf"
                  className="download-btn"
                >
                  Download PDF
                </a>
                <a
                  href="/resume"
                  className="view-btn"
                >
                  View Resume
                </a>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;